import { Link } from 'react-router-dom'
import { useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { Table } from '../../components/DataTable'
import { projects } from '../../api/fee'
import type { ProjectUser } from '../../api/types'
import { PageTitle, QueryState } from '../../components/common'
import { useProject } from '../../layout/projectContext'
import { ADMIN_USER_SECTIONS } from './AdminUserLocalMenu'

/** Port of `AdminUserListComponent` (`projects/:projectId/admin/users`):
 * the project's users (`GET /projects/{id}/users` — the plain membership
 * list, as in legacy) with one link per per-user admin section. */
export function AdminUserListPage() {
  const { projectId, project } = useProject()
  const users = useApiQuery(() => projects.users(projectId), [projectId])
  const base = `/projects/${encodeURIComponent(projectId)}/admin/users`

  const columns: Column<ProjectUser>[] = [
    { key: 'username', label: 'Email' },
    {
      key: 'actions',
      label: '',
      sortable: false,
      format: (_v, row) => (
        <span className="portal-inline-actions">
          {ADMIN_USER_SECTIONS.map((s) => (
            <Link
              key={s.path}
              className="portal-button-link"
              to={`${base}/${s.path}?email=${encodeURIComponent(row.username)}`}
            >
              {s.label}
            </Link>
          ))}
        </span>
      ),
    },
  ]

  return (
    <div className="portal-card">
      <PageTitle title={`Users — ${project.name}`} />
      <QueryState loading={users.loading} error={users.error}>
        <div className="portal-table-scroll">
          <Table columns={columns} rows={users.data ?? []} rowKey={(r) => r.username} initialSort={{ key: 'username', dir: 'asc' }} />
        </div>
        {users.data?.length === 0 && <p className="portal-text-muted">No users.</p>}
      </QueryState>
    </div>
  )
}
